<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">{{$t('WORKLIST.REALIZARENCAIXE')}}</p>
        </header>
        <section class="modal-card-body">
            <b-field>
                <b-datetimepicker rounded
                                  :placeholder="$t('SISTEMA.SELECIONEDATAHORA')"
                                  icon="calendar-today"
                                  v-model="dataSelecionada"
                                  inline
                                  horizontal-time-picker>
                </b-datetimepicker>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <b-button type="is-success"
                      @click="alterarData">{{$t('SISTEMA.CONFIRMAR')}}</b-button>
            <b-button @click="$emit('close')">{{$t('ALTERARDATAULTIMAREFEICAO.CANCELAR')}}</b-button>
        </footer>
    </div>
</template>

<script>
    export default {
        props: {
            agenda: Object,
        },    
        data() {
            return {
                dataSelecionada: new Date()
            }
        },
        methods: {
        
            alterarData() {

                this.$emit('encaixePaciente', this.agenda,this.$moment(this.dataSelecionada).toDate())
                this.$emit('close')
            }
        }
    }
</script>